import { Moment } from 'moment';
import { EmailContact } from './email-contact.model';
import { PhoneContact } from './phone-contact.model';
import { Address } from './address.model';
import { PetitionFeesInfo } from './petitionFeesInfo.model';

export class Attorney {
    constructor(obj: Partial<Attorney>) {
        Object.assign(this, obj);
    }
    id?: number;
    title?: string;
    description?: string;
    companyLogo?: Blob;
    logoFile?: string;
    companyName?: string;
    companyCode?: String;
    feiNo?: String;
    establishedDate?: Moment;
    incorporationLoc?: {
        countryCode?: String;
    };
    companyType?: {};
    emailContacts: [];
    emailContact?: EmailContact;
    altEmailContact?: EmailContact;
    phoneContact?: PhoneContact;
    mobileContact?: PhoneContact;
    phoneContacts?: [];
    address?: Address[]
    employeeCount?: number;
    grossAnnualIncome?: String;
    classification?: String;
    netAnnualIncome?: String;
    mgrExecUSCount?: String;
    mgrExecNonUSCount?: String;
    dotCode?: String;
    naicsCode?: String;
    businessType?: [
        { type?: number }
    ];
    petitionFeesInfo: PetitionFeesInfo[];
}

export class AttorneyConnect {
    constructor(obj: Partial<AttorneyConnect>) {
        Object.assign(this, obj);
    }
    emailId?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    note?: string;
    firmName?: string;
}